import React from "react";

import Button from "@common/components/Button/Button";
import Card from "@common/components/Card/Card";
import Heading from "@common/components/Heading/Heading";
import { useModal } from "@common/components/Modal/Modal";
import identifiers from "@common/util/identifiers.json";
import { useAuthContext } from "@main/context/Auth/Auth.context";

import SecurityCardModalForm from "./SecurityCardModalForm";

export const SecurityCard = () => {
  const { userData } = useAuthContext();
  const {
    Modal: SecurityCardModal,
    toggle: toggleSecurityModal,
    modalProps,
  } = useModal({ size: "narrow", hash: "#change-password" });

  return (
    <>
      <Card>
        <Heading
          as="h3"
          heading3
          marginBottom={24}
          testId={identifiers["info.security.header"]}
        >
          Security
        </Heading>

        <Button
          size="small"
          testId={
            userData?.has_password
              ? identifiers["info.security.button.changePass"]
              : identifiers["info.security.button.setPass"]
          }
          onClick={toggleSecurityModal}
        >
          {userData?.has_password ? "Change password" : "Set password"}
        </Button>
      </Card>

      <SecurityCardModalForm
        toggle={toggleSecurityModal}
        Modal={SecurityCardModal}
        internalProps={modalProps}
      />
    </>
  );
};
